import { MetricAnthropometryEntryType } from "apps/web/src/components/AnthropometryEntry/Form/MetricAnthropometryEntryFormSchema";
import { MetricAnthropometryEntryForm } from "apps/web/src/components/AnthropometryEntry/Form/MetricAnthropometryForm";
import { UseFormReturn } from "react-hook-form";
import { AnthropometryEntryFormAlertDisplayHeader } from "./AnthropometryEntryFormAlertDisplayHeader";

interface CreateMetricAnthropometryEntryFormProps {
  form: UseFormReturn<MetricAnthropometryEntryType>;
}

export const CreateMetricAnthropometryEntryForm = ({ form }: CreateMetricAnthropometryEntryFormProps) => (
  <>
    <AnthropometryEntryFormAlertDisplayHeader />
    <MetricAnthropometryEntryForm form={form} />
  </>
);
